//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
import "../no/SelectTaggedObject.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
let d=[[[0,"DirectionOfInterface",1,"Direction",0],[0,"FixingType",1,0],[0,"MountingInterfaceType",1,0],[0,"Name",1,0],[0,"ParallelReferenceObject",1,"Direction",0],[0,"ReceptacleType",1,0],[0,"SpecifyFace",1,"ScCollector",0],[1,"SpecifyLine",0,"SelectTaggedObject",0],[0,"SpecifyPoint",1,"Point",0]],[[[],"AddInterface",{},0,0],[["mountingInterfaces"],"RemoveInterfaces",{},1,0],[["fixingName"],"SetDefaultFixingInterface",{},1,0]],[]];
SPLM.AME.MountingInterfaceBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.MountingInterfaceBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.MountingInterfaceBuilder.InterfaceType = Object.freeze({
    "Fixing" : "Fixing", "ComponentReceptacle" : "ComponentReceptacle"});

SPLM.AME.MountingInterfaceBuilder.FixingPolicy = Object.freeze({
    "Point" : "Point", "Face" : "Face"});

SPLM.AME.MountingInterfaceBuilder.ReceptaclePolicy = Object.freeze({
    "Fixed" : "Fixed", "AxisMovement" : "AxisMovement", "PlaneMovement" : "PlaneMovement"});

export default SPLM;